import React from "react";
import "./styles.css";
import { HHTabs } from "../../Tabs";
import { ByFirstPayment } from "./ByFirstPayment";
import { ByPeriod } from "./ByPeriod";
import { INSTALLMENT_PLAN_TYPES } from "../constants.ts";
import { ShareUSP } from "../../../../pages/HousingComplex/components/ShareUSP";
import { PaidHoc } from "../../../hocs/PaidHoc";
import { useBranding } from "../../../../integrations/branding";

export const InstallmentPlan = ({
  option,
  setOption,
  hasMultiTypes,
  housing,
  installmentPlans,
  shareData,
  setShareData,
    type,
}) => {
  const { isShowcase } = useBranding();

  const content = (
    <>
      {hasMultiTypes && (
        <HHTabs
          activeTab={option}
          setActiveTab={setOption}
          tabs={installmentPlans}
          className="!mt-0"
          listClassName={isShowcase ? "pricing-showcase_tabs-list" : ""}
          triggerClassName={isShowcase ? "pricing-showcase_tabs-trigger" : ""}
        />
      )}
      {option === INSTALLMENT_PLAN_TYPES.byFirstPayment.id && (
        <ByFirstPayment
          housingName={housing.housingName}
          setShareData={setShareData}
          type={type}
        />
      )}
      {option === INSTALLMENT_PLAN_TYPES.byPeriod.id && (
        <ByPeriod
          housingName={housing.housingName}
          setShareData={setShareData}
          type={type}
        />
      )}
      <ShareUSP shareData={shareData} housing={housing} propertyType={type} />
    </>
  );

  return (
    <div className="space-y-4 sm:space-y-5">
      {isShowcase ? content : <PaidHoc>{content}</PaidHoc>}
    </div>
  );
};
